import { TFunction } from 'core/i18n/i18n';

export const getCustomMessages = (t: TFunction, mainView: boolean = false) => ({
    mandatory: {
        lmsField: {
            warning: {
                mapping: t(
                    'settings.integrations.lms-api-integration.mapping.fields.lms-field.mandatory.warning.non-exist.editing'
                ),
            },
        },
        pocField: {
            warning: {
                'non-exist': t(
                    'settings.integrations.lms-api-integration.mapping.fields.poc-field.mandatory.warning.non-exist.editing'
                ),
            },
        },
    },
    optional: {
        lmsField: {
            warning: {
                mapping: t(
                    'settings.integrations.lms-api-integration.mapping.fields.lms-field.optional.warning.non-exist.editing'
                ),
            },
        },
        pocField: {
            warning: {
                'non-exist': t(
                    mainView
                        ? 'settings.integrations.lms-api-integration.mapping.fields.poc-field.optional.warning.non-exist'
                        : 'settings.integrations.lms-api-integration.mapping.fields.poc-field.optional.warning.non-exist.editing'
                ),
            },
        },
    },
});
